import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import searchIcon from '../../../../assets/myVets/search-icon.svg';
import arrowDownIcon from '../../../../assets/chevron-disabled.svg';
import searchDisabledIcon from '../../../../assets/petDemos/search-gray.svg';

import { CustomOption } from './CustomOption';
import { CustomMultiValue } from './CustomMultiValue';
import { CustomMenuList } from './CustomMenuList';
import {
  convertPetsToOptions,
  filterPetsBySpecie,
  filterPetByName,
} from './utils/dropdownUtils';
import { PetPill } from './PetPill';

import styles from './css/Dropdown.module.css';

const Dropdown = ({
  disabled = false,
  disabledBecauseOneOption = false,
  headerComponent = null,
  onSelectionChange = () => { },
  pets = [],
  placeholder = '',
  removalDate = '', // removal id...
  selectedPets = [],
  specieFilter = null,
}) => {
  const { t } = useTranslation('petDemos');
  // Filter and convert pets to react-select format
  const options = useMemo(() => {
    const filteredPets = filterPetsBySpecie({ pets, specieFilter });
    return convertPetsToOptions(filteredPets);
  }, [pets, specieFilter]);

  // Convert selectedPets to react-select format
  const value = useMemo(
    () => convertPetsToOptions(selectedPets),
    [selectedPets],
  );

  const handleChange = (selectedOptions) => {
    // Convert back to pet objects
    const updated = (selectedOptions || [])
      .map((option) => ({ ...option.pet, removalDate }));
    onSelectionChange(updated);
  };

  useEffect(() => {
    // automatic selection if only one option available
    if (disabledBecauseOneOption) {
      handleChange([{
        label: disabledBecauseOneOption.Name,
        pet: disabledBecauseOneOption,
        value: disabledBecauseOneOption.Id,
      }]);
    }
  }, [disabledBecauseOneOption]);

  // very custom design when there is only one option
  if (disabledBecauseOneOption && !false) {
    return (
      <div className={styles.dropdownContainer}>
        {headerComponent}

        <div className={styles.singleOptionDisabled}>
          <PetPill disabled pet={disabledBecauseOneOption} />

          <img alt="" src={searchDisabledIcon} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dropdownContainer}>
      {headerComponent}

      <Select
        classNamePrefix="dropdown"
        closeMenuOnSelect={false}
        components={{
          ClearIndicator: () => null,
          DropdownIndicator: ({ selectProps }) => (
            <img
              alt=""
              className={`${styles.inputIcon} ${
                selectProps.menuIsOpen ? '' : styles.rotate
              }`}
              src={selectProps.menuIsOpen ? searchIcon : arrowDownIcon}
            />
          ),
          IndicatorSeparator: () => null,
          MenuList: CustomMenuList,
          MultiValue: CustomMultiValue,
          Option: CustomOption,
        }}
        filterOption={filterPetByName}
        hideSelectedOptions={false}
        isClearable={false}
        isDisabled={disabled}
        isMulti
        onChange={handleChange}
        options={options}
        placeholder={placeholder
          || t('completePetRemoval.selectPetPlaceholder')}
        value={value}
      />
    </div>
  );
};

export { Dropdown };
